<template>
  <TicketBoxAdvanceSelect
    :data="ticketBoxList"
    :selectedData="compact([selectedId])"
    @confirm="onConfirm"
    @close="$emit('close')"
  />
</template>

<script>
import { defineComponent } from 'vue'
import { compact } from 'lodash'
import TicketBoxAdvanceSelect from '@/components/Select/TicketBoxAdvanceSelect.vue'

export default defineComponent({
  name: 'TicketBoxSelectModal',
  components: { TicketBoxAdvanceSelect },
  props: {
    ticketBoxList: { type: Array, default: () => [] },
    selectedId: { type: String, default: null },
  },
  emits: ['confirm', 'close'],
  setup (props, { emit }) {
    const onConfirm = (selected) => {
      if (selected.length > 0) emit('confirm', selected[0])
    }

    return { compact, onConfirm }
  },
})
</script>
